import {
  CaseRotationStatus,
  ENOPCaseStatus,
  NEW_CASES_ROTATION_GROUP,
  OFF_OCS_STATUSES,
} from '#entities';

type RenderItem =
  | { kind: 'status'; status: CaseRotationStatus }
  | {
      kind: 'group';
      key: 'OFF_OCS';
      label: string;
      members: readonly CaseRotationStatus[];
    };

export const RENDER_SEQUENCE: readonly RenderItem[] = [
  { kind: 'status', status: NEW_CASES_ROTATION_GROUP },
  { kind: 'status', status: ENOPCaseStatus.ResourcesBooked },
  { kind: 'status', status: ENOPCaseStatus.ResourceDeployed },
  { kind: 'status', status: ENOPCaseStatus.AtDonorHospital },
  { kind: 'status', status: ENOPCaseStatus.OrganOnOCS },
  { kind: 'status', status: ENOPCaseStatus.DeployedToTXCenter },
  { kind: 'status', status: ENOPCaseStatus.AtTXCenter },
  {
    kind: 'group',
    key: 'OFF_OCS',
    label: 'Off OCS',
    members: OFF_OCS_STATUSES,
  },
  { kind: 'status', status: ENOPCaseStatus.ReturningToBase },
] as const;
